// frontend/src/components/ui/ThemeSwitcher.jsx
import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { Sun, Moon, Monitor } from 'lucide-react';

export const ThemeSwitcher = ({ className = '' }) => {
  const { theme, setTheme } = useTheme();

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      <button
        onClick={() => setTheme('light')}
        className={`p-2 rounded-md ${
          theme === 'light' 
            ? 'bg-button-primary-bg text-button-primary-text' 
            : 'text-text-primary hover:bg-background-tertiary'
        }`}
        aria-label="Light mode"
        title="Light mode"
      >
        <Sun size={18} />
      </button>
      
      <button
        onClick={() => setTheme('dark')}
        className={`p-2 rounded-md ${
          theme === 'dark' 
            ? 'bg-button-primary-bg text-button-primary-text' 
            : 'text-text-primary hover:bg-background-tertiary'
        }`}
        aria-label="Dark mode"
        title="Dark mode"
      >
        <Moon size={18} />
      </button>
      
      <button
        onClick={() => setTheme('system')}
        className={`p-2 rounded-md ${
          theme === 'system' 
            ? 'bg-button-primary-bg text-button-primary-text' 
            : 'text-text-primary hover:bg-background-tertiary'
        }`}
        aria-label="System preference"
        title="System preference"
      >
        <Monitor size={18} />
      </button>
    </div>
  );
};

export default ThemeSwitcher;